import React from "react";
import Autocomplete from "./Autocomplete";
import { useProject } from "../../contexts/project";
import { getCostCenterValue } from "../../views/capture/FieldsIdentifiers";

export default function CostCenterSelect({
  name = "costCenterId",
  label = "Cost Center",
  disabled = false,
  size = "small",
  ...props
}) {
  const currentProject = useProject();

  const activeCostCenters = (currentProject?.costCenters || []).filter(
    costCenter => costCenter.active !== false && !costCenter.disabled
  );

  const costCenterOptions = activeCostCenters
    .map(costCenter => ({
      value: parseInt(costCenter.id),
      label: getCostCenterValue(costCenter),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Autocomplete
      name={name}
      label={label}
      options={costCenterOptions}
      disabled={disabled}
      showNAButton={false}
      {...props}
    />
  );
}
